import { useEffect } from "react";
import { logo } from "../assets/icons";

function Loading() {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  return (
    <div
      className={`fixed inset-0 w-screen z-[1000] h-screen flex flex-col gap-8 justify-center items-center bg-white text-black overflow-hidden`}
    >
      <span className="w-[200px] animate-ping-slow text-teal">{logo}</span>
    </div>
  );
}

export default Loading;
